(function() {
  function getYouTubeVideoId(value) {
    if (!value) return '';

    const normalizedValue = String(value).trim();
    if (/^[A-Za-z0-9_-]{6,}$/.test(normalizedValue)) return normalizedValue;

    const match = normalizedValue.match(
      /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:[^#]*&)?v=|shorts\/|embed\/|live\/))([A-Za-z0-9_-]{6,})/i
    );
    return match ? match[1] : '';
  }

  function isYouTubeShortsUrl(value) {
    return /youtube(?:-nocookie)?\.com\/shorts\//i.test(String(value || '').trim());
  }

  function updateUploadedVideoOrientation(modal, video) {
    if (!modal || !video || !video.videoWidth || !video.videoHeight) return;
    const isPortrait = video.videoHeight > video.videoWidth;
    modal.classList.toggle('video-popup-modal--portrait', isPortrait);

    if (isPortrait) {
      const aspectRatio = video.videoWidth / video.videoHeight;
      modal.style.setProperty('--video-aspect-ratio', `${video.videoWidth} / ${video.videoHeight}`);
      modal.style.setProperty(
        '--video-viewport-width',
        `${Number((aspectRatio * 64).toFixed(4))}dvh`
      );
    } else {
      modal.style.removeProperty('--video-aspect-ratio');
      modal.style.removeProperty('--video-viewport-width');
    }
  }

  function closeVideoModal(modal) {
    if (!modal) return;

    const modalVideo = modal.querySelector('video');
    const modalYoutube = modal.querySelector('iframe');

    if (modalVideo) {
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.hidden = true;
    }

    if (modalYoutube) {
      modalYoutube.removeAttribute('src');
      modalYoutube.hidden = true;
    }

    modal.classList.remove('video-popup-modal--portrait');
    modal.style.removeProperty('--video-aspect-ratio');
    modal.style.removeProperty('--video-viewport-width');
    modal.style.display = 'none';
  }

  function openVideoModal(videoTrigger) {
    const modalId = videoTrigger.dataset.videoModalId;
    const modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return;

    const modalVideo = modal.querySelector('video');
    const modalYoutube = modal.querySelector('iframe');
    if (!modalVideo || !modalYoutube) return;

    const isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    const desktopVideoType = videoTrigger.dataset.desktopVideoType;
    const desktopVideoValue = videoTrigger.dataset.desktopVideoValue;
    const mobileVideoType = videoTrigger.dataset.mobileVideoType;
    const mobileVideoValue = videoTrigger.dataset.mobileVideoValue;
    const hasMobileVideo = Boolean(mobileVideoType && mobileVideoValue);
    const videoType = isMobile && hasMobileVideo ? mobileVideoType : desktopVideoType;
    const videoValue = isMobile && hasMobileVideo ? mobileVideoValue : desktopVideoValue;

    if (!videoType || !videoValue) return;

    modal.classList.remove('video-popup-modal--portrait');
    modal.style.removeProperty('--video-aspect-ratio');
    modal.style.removeProperty('--video-viewport-width');

    if (videoType === 'youtube') {
      const youtubeVideoId = getYouTubeVideoId(videoValue);
      if (!youtubeVideoId) return;

      modalVideo.pause();
      modalVideo.onloadedmetadata = null;
      modalVideo.removeAttribute('src');
      modalVideo.hidden = true;
      modal.classList.toggle(
        'video-popup-modal--portrait',
        isYouTubeShortsUrl(videoValue) ||
          (isMobile && videoTrigger.dataset.mobileVideoOverride === 'true')
      );
      modalYoutube.src = `https://www.youtube.com/embed/${encodeURIComponent(youtubeVideoId)}?autoplay=1&rel=0&playsinline=1`;
      modalYoutube.hidden = false;
    } else {
      modalYoutube.removeAttribute('src');
      modalYoutube.hidden = true;
      modalVideo.onloadedmetadata = function() {
        updateUploadedVideoOrientation(modal, modalVideo);
      };
      modalVideo.src = videoValue;
      modalVideo.hidden = false;
      modalVideo.load();
    }

    modal.style.display = 'flex';

    if (videoType !== 'youtube') {
      const playPromise = modalVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {});
      }
    }
  }

  function handleVideoActivation(event, explicitTrigger) {
    const clickedElement = event.target && event.target.closest ? event.target : null;
    if (!clickedElement && !explicitTrigger) return;

    const videoTrigger =
      explicitTrigger ||
      (clickedElement && clickedElement.closest('.video-card-trigger'));
    if (videoTrigger) {
      event.preventDefault();
      openVideoModal(videoTrigger);
    }
  }

  function handleVideoClose(event, closeControl) {
    event.preventDefault();
    closeVideoModal(closeControl.closest('.video-popup-modal'));
  }

  function getItemsPerPage() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 3 : 6;
  }

  function initVideoPagination(section) {
    if (!section || section.dataset.videoPaginationInitialized === 'true') return;

    const items = Array.from(section.querySelectorAll('.kik_video_items'));
    const filterButtons = Array.from(section.querySelectorAll('[data-video-filter]'));
    const searchInputs = Array.from(section.querySelectorAll('[data-video-search]'));
    const searchClearButtons = Array.from(section.querySelectorAll('[data-video-search-clear]'));
    const mobileSearchIcons = Array.from(section.querySelectorAll('[data-mobile-search-icon]'));
    const emptyMessage = section.querySelector('[data-video-empty]');
    const paginationControls = section.querySelector('[data-video-pagination-controls]');
    const numbersContainer = section.querySelector('[data-video-page-numbers]');
    const previousButton = section.querySelector('[data-video-page-prev]');
    const nextButton = section.querySelector('[data-video-page-next]');
    const mobileFilters = section.querySelector('[data-mobile-video-filters]');
    const mobileFilterValue = section.querySelector('[data-mobile-filter-value]');
    const sectionHeading = section.querySelector('.kik-video-pagination-header');
    const allLabel = section.dataset.videoAllLabel || 'All';
    const pageLabel = section.dataset.videoPageLabel || 'Page';

    if (
      !items.length ||
      !paginationControls ||
      !numbersContainer ||
      !previousButton ||
      !nextButton
    ) {
      return;
    }

    section.dataset.videoPaginationInitialized = 'true';

    let currentFilter = 'all';
    let currentSearch = '';
    let currentSearchLabel = '';
    let currentPage = 1;
    let lastItemsPerPage = getItemsPerPage();

    function getFilteredItems() {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

      return items.filter(function(item) {
        const itemType = item.dataset.type || '';
        const matchesType = currentFilter === 'all' || itemType === currentFilter;
        const searchableText = item.textContent.toLowerCase();
        const matchesSearch = !currentSearch || searchableText.includes(currentSearch);
        const matchesViewport = isMobile
          ? item.dataset.hasMobileVideo === 'true'
          : item.dataset.hasDesktopVideo === 'true';
        return matchesType && matchesSearch && matchesViewport;
      });
    }

    function scrollToSection() {
      if (!sectionHeading || typeof sectionHeading.scrollIntoView !== 'function') return;
      sectionHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function updateFilterControls() {
      filterButtons.forEach(function(button) {
        const isMobileFilter = Boolean(button.closest('[data-mobile-video-filters]'));
        const isActive =
          button.dataset.videoFilter === currentFilter &&
          (!currentSearch || !isMobileFilter);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (mobileFilterValue) {
        const activeButton = filterButtons.find(function(button) {
          return button.dataset.videoFilter === currentFilter;
        });
        mobileFilterValue.textContent = currentSearchLabel ||
          (activeButton ? activeButton.textContent.trim() : allLabel);
      }

      searchClearButtons.forEach(function(button) {
        button.hidden = !currentSearch;
      });

      mobileSearchIcons.forEach(function(icon) {
        icon.hidden = Boolean(currentSearch);
      });
    }

    function renderPagination(totalPages) {
      numbersContainer.innerHTML = '';

      for (let page = 1; page <= totalPages; page += 1) {
        const pageButton = document.createElement('button');
        pageButton.type = 'button';
        pageButton.textContent = String(page);
        pageButton.classList.toggle('is-active', page === currentPage);
        pageButton.setAttribute('aria-label', `${pageLabel} ${page}`);
        if (page === currentPage) pageButton.setAttribute('aria-current', 'page');
        pageButton.addEventListener('click', function() {
          currentPage = page;
          render();
          scrollToSection();
        });
        numbersContainer.appendChild(pageButton);
      }

      previousButton.disabled = currentPage <= 1;
      nextButton.disabled = currentPage >= totalPages;
      paginationControls.hidden = totalPages <= 1;
    }

    function render() {
      const filteredItems = getFilteredItems();
      const itemsPerPage = getItemsPerPage();
      const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

      if (currentPage > totalPages) currentPage = totalPages || 1;

      items.forEach(function(item) {
        item.hidden = true;
      });

      const startIndex = (currentPage - 1) * itemsPerPage;
      filteredItems.slice(startIndex, startIndex + itemsPerPage).forEach(function(item) {
        item.hidden = false;
      });

      if (emptyMessage) emptyMessage.hidden = filteredItems.length !== 0;
      renderPagination(totalPages);
    }

    filterButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        currentFilter = button.dataset.videoFilter || 'all';
        currentPage = 1;
        updateFilterControls();
        render();

        if (mobileFilters && button.closest('[data-mobile-video-filters]')) {
          mobileFilters.open = false;
        }
      });
    });

    searchInputs.forEach(function(input) {
      input.addEventListener('input', function() {
        currentSearch = input.value.trim().toLowerCase();
        currentPage = 1;
        searchInputs.forEach(function(otherInput) {
          if (otherInput !== input) otherInput.value = input.value;
        });
        currentSearchLabel = input.value.trim();
        updateFilterControls();
        render();
      });
    });

    searchClearButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        currentSearch = '';
        currentSearchLabel = '';
        currentPage = 1;
        searchInputs.forEach(function(input) {
          input.value = '';
        });
        updateFilterControls();
        render();

        const searchInput = button.parentElement &&
          button.parentElement.querySelector('[data-video-search]');
        if (searchInput && typeof searchInput.focus === 'function') searchInput.focus();
      });
    });

    previousButton.addEventListener('click', function() {
      if (currentPage <= 1) return;
      currentPage -= 1;
      render();
      scrollToSection();
    });

    nextButton.addEventListener('click', function() {
      const totalPages = Math.ceil(getFilteredItems().length / getItemsPerPage());
      if (currentPage >= totalPages) return;
      currentPage += 1;
      render();
      scrollToSection();
    });

    if (window.addEventListener) {
      window.addEventListener('resize', function() {
        const nextItemsPerPage = getItemsPerPage();
        if (nextItemsPerPage === lastItemsPerPage) return;
        lastItemsPerPage = nextItemsPerPage;
        currentPage = 1;
        render();
      });
    }

    updateFilterControls();
    render();
  }

  function initVideoPaginationSections(root) {
    if (!root) return;

    if (root.matches && root.matches('[data-kik-video-pagination]')) {
      initVideoPagination(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('[data-kik-video-pagination]').forEach(initVideoPagination);
    }
  }

  window.kikVideoPaginationActivate = handleVideoActivation;
  window.kikVideoPaginationClose = handleVideoClose;

  if (window.__kikVideoPaginationKeydownHandler) {
    document.removeEventListener('keydown', window.__kikVideoPaginationKeydownHandler);
  }

  window.__kikVideoPaginationKeydownHandler = function(event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.video-popup-modal').forEach(function(modal) {
      if (modal.style.display !== 'none') closeVideoModal(modal);
    });
  };

  document.addEventListener('keydown', window.__kikVideoPaginationKeydownHandler);

  if (window.__kikVideoPaginationOutsideClickHandler) {
    document.removeEventListener('click', window.__kikVideoPaginationOutsideClickHandler);
  }

  window.__kikVideoPaginationOutsideClickHandler = function(event) {
    document.querySelectorAll('[data-mobile-video-filters][open]').forEach(function(details) {
      if (!details.contains(event.target)) details.open = false;
    });
  };

  document.addEventListener('click', window.__kikVideoPaginationOutsideClickHandler);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initVideoPaginationSections(document);
    });
  } else {
    initVideoPaginationSections(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initVideoPaginationSections(event.target);
  });
})();
